import { useFabriqStore } from "@/store/fabriq";
import config from "../config";

export function useTransformLegacyPermalinks() {
  const fabriqStore = useFabriqStore();

  return (url: string) => {
    const baseUrl = fabriqStore.url;
    if (!baseUrl) {
      return url;
    }
    if (!url.startsWith(config.legacyPermalinkBaseUrl)) {
      return url;
    }
    return url.replace(
      config.legacyPermalinkBaseUrl,
      `${baseUrl}${config.permalinksPath}`
    );
  };
}
